export default {
  title: 'Détails fiscaux',
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    success: 'Informations enregistrées avec succès.',
  },
};
